import memoize from 'memoize-one';
import { Platform } from 'react-native';
export const weightToFont = memoize(function (weight) {
  let universal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (Platform.OS === 'web' && universal) {
    switch (weight) {
      case 'light':
        return 'Roboto-Light, Tahoma, Helvetica, Arial, Verdana';
      case 'medium':
        return 'Roboto-Medium, Tahoma, Helvetica, Arial, Verdana';
      case 'bold':
        return 'Roboto-Bold, Tahoma, Helvetica, Arial, Verdana';
      case 'heavy':
        return 'Roboto-Black, Tahoma, Helvetica, Arial, Verdana';
      case 'regular':
      default:
        return 'Roboto-Regular, Tahoma, Helvetica, Arial, Verdana';
    }
  } else {
    switch (weight) {
      case 'light':
        return 'Roboto-Light';
      case 'medium':
        return 'Roboto-Medium';
      case 'bold':
        return 'Roboto-Bold';
      case 'heavy':
        return 'Roboto-Black';
      case 'regular':
      default:
        return 'Roboto-Regular';
    }
  }
});